import React, { useState } from "react"
import { twJoin } from "tailwind-merge"
import { IoIosArrowDown } from "react-icons/io"
import { trackEvent } from "@/helpers/ga"

export function Doubts() {
  const doubts = [
    {
      track: "qual-o-periodo-de-gravacao-dos-feats",
      title: "Qual o período de gravação dos feats?",
      text: <p>As gravações ocorrerão entre dezembro e fevereiro.</p>,
    },
    {
      track: "quando-serao-os-lancamentos-dos-feats",
      title: "Quando serão os lançamentos dos feats?",
      text: <p>Os lançamentos ocorrerão entre fevereiro e abril.</p>,
    },
    {
      track: "tem-algum-canal-para-tirar-mais-duvidas",
      title: "Tem algum canal para tirar mais dúvidas?",
      // text: (<p>As dúvidas relativas ao prêmio poderão ser encaminhadas por mensagem via whatsapp ou email, até 3 dias antes da data do encerramento das incrições. Whatsapp: <a className="underline" href="https://api.whatsapp.com/send/?phone=5511933874080" target="_blank" title="(11) 93387-4080">(11) 93387-4080</a> Email: <a className="underline" href="mailto:atendimento@elofeatdossonhos.com.br" target="_blank" title="atendimento@elofeatdossonhos.com.br">atendimento@elofeatdossonhos.com.br</a>.</p>)
      text: (
        <p>
          Precisa falar conosco? <br />
          Entre em contato através do email:{" "}
          <a
            className="underline"
            href="mailto:atendimento@elofeatdossonhos.com.br"
            target="_blank"
            title="atendimento@elofeatdossonhos.com.br"
          >
            atendimento@elofeatdossonhos.com.br
          </a>
          .
        </p>
      ),
    },
  ]

  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const handleClick = (index: number) => {
    setOpenIndex(openIndex == index ? null : index)
  }

  return (
    <section className="bg-green-dark lg:py-16 py-10 dark:bg-black dark:border-t" id="duvidas">
      <h2 className="font-serif text-sand text-center lg:text-6xl text-3xl w-full border-b border-sand pb-4">
        AINDA TEM DÚVIDAS? A GENTE RESPONDE
      </h2>

      <div className="container flex flex-col">
        {doubts && (
          <ul>
            {doubts.map((item, index) => (
              <li
                key={index}
                className="border-b border-sand pb-4 lg:mt-7 mt-6"
                onClick={() => {
                  trackEvent("interaction", item.title)
                }}
              >
                <div
                  className="flex justify-between items-center mb-4 cursor-pointer"
                  onClick={() => {
                    handleClick(index)
                  }}
                >
                  <h3
                    className={twJoin(
                      openIndex == index ? "text-yellow" : "text-sand",
                      "font-bold text-xl transition-all duration-300 ease-in-out",
                    )}
                  >
                    {index + 1}. {item.title}
                  </h3>

                  <div
                    className={twJoin(
                      openIndex == index && "-rotate-180",
                      "bg-yellow rounded-full p-[2px] transform transition-all duration-300 ease-in-out",
                    )}
                  >
                    <IoIosArrowDown className="text-2xl" />
                  </div>
                </div>
                <div
                  className={twJoin(
                    openIndex == index ? "max-h-max" : "max-h-0",
                    "text-sand text-xl overflow-hidden transition-all duration-300 ease-in-out",
                  )}
                >
                  {item.text}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  )
}
